/**
 * Back-to-top control for long articles.
 *
 * Appears once the reader is a screen and a half down and there is meaningfully
 * more page below, so it never shows on a short post where it would just be
 * clutter. Sits bottom-LEFT because the Gorgias chat launcher owns bottom-right
 * on every page of this store.
 */
(function () {
  var btn = document.querySelector('[data-back-to-top]');
  if (!btn) return;

  var SHOW_AFTER = 900;
  var shown = false;
  var ticking = false;

  function update() {
    ticking = false;
    var docH = document.documentElement.scrollHeight;
    var tallEnough = docH > window.innerHeight * 2.5;
    var should = tallEnough && window.scrollY > SHOW_AFTER;
    if (should === shown) return;
    shown = should;
    btn.classList.toggle('is-visible', shown);
    btn.setAttribute('aria-hidden', shown ? 'false' : 'true');
    btn.tabIndex = shown ? 0 : -1;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    // Return focus to the top of the document so keyboard and screen-reader
    // users land where the page visually lands.
    var target = document.querySelector('h1') || document.body;
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
